/**
 * @file 会员订阅套餐接口
 */
import type {MembershipRes, QuesTipsRes} from './interface';
import {request} from '@/services';

const MEMBERSHIP_ENDPOINTS = {
    /** 获取会员套餐列表 */
    PLANS: '/proxy-aicomic/sku/membership',
    /** 获取会员常见问题和提示信息 */
    QUESTION_AND_TIPS: '/proxy-aicomic/sku/tips',
} as const;

/**
 * 获取会员套餐列表
 */
export const getSubscriptionPlans = () => request.get<MembershipRes>(MEMBERSHIP_ENDPOINTS.PLANS);

/**
 * 获取会员常见问题和提示信息
 */
export const getQuestionAndTips = () =>
    request.get<QuesTipsRes>(MEMBERSHIP_ENDPOINTS.QUESTION_AND_TIPS);
